<template>
	<section class="flex">
		<section class="common-sub-top container">
			<section class="top-info-wrap">
				<div class="prev-wrap">
					<a @click="pageBefore()" class="prev"></a>
					<span class="name">문진표설정</span>
				</div>

				<div class="select-wrap">
					<div class="select" @click="clickCheckupSave()">저장</div>
				</div>
			</section>
		</section>

		<section class="content question">
			<div>
				<div class="li check-group">
					<input type="checkbox" id="chkHosp" />
					<label for="chkHosp">병원 문진</label>
				</div>
				<div class="li check-group">
					<input type="checkbox" id="chkNat" />
					<label for="chkNat">국가 검진</label>
				</div>
				<div class="li check-group" v-if="showFlag === true">
					<input type="checkbox" id="chkChild" />
					<label for="chkChild">영유아 검진</label>
				</div>
				<div class="li check-group" v-if="licenseType === '2'">
					<input type="checkbox" id="chkPsy" />
					<label for="chkPsy">정신건강 문진</label>
				</div>
			</div>

			<div>
				<div class="li spin-group">
					<span>비밀번호 설정</span>
					<div>
						<input type="checkbox" id="setPw" v-model="setPw" @change="changeSetPw" />
						<label for="setPw"></label>
					</div>
				</div>
			</div>
		</section>

		<!-- msg 문구와 Ok 클릭 시 실행할 함수를 전달한다. -->
		<ModalOKCancel :propData="modalData" @okFunction="modalOKFunction" />

		<!-- 비밀번호 팝업 -->
		<PinPassword ref="pinPasswordRef" :propData="propData" @childFunc="parentFunc" />
	</section>
</template>

<script>
import $ from 'jquery';
import ModalOKCancel from '@/components/modal/ModalOKCancel.vue';
import PinPassword from '@/components/popup/PinPassword';
import { popOpenAndScrollNone } from '@/utils/UtilPopup';

export default {
	components: {
		ModalOKCancel,
		PinPassword
	},
	data: () => ({
		modalData: {
			id: 'SettingQuestionModal',
			msg: ''
		},
		showFlag: false,
		setPw: false,
		password: '',

		propData: {}
	}),
	computed: {
		licenseType() {
			return this.$store.state.settingInfo.licenseType;
		}
	},
	mounted() {
		// console.log('mounted');
		// console.log(this.$store.state.settingInfo);
		try {
			if (this.$store.state.settingInfo.chkHosp === 'Y') {
				$('input:checkbox[id=chkHosp]').prop('checked', true);
			}
			if (this.$store.state.settingInfo.chkNat === 'Y') {
				$('input:checkbox[id=chkNat]').prop('checked', true);
			}
			if (this.$store.state.settingInfo.chkPsy === 'Y') {
				$('input:checkbox[id=chkPsy]').prop('checked', true);
			}
			if (this.$store.state.settingInfo.chkChild === 'Y') {
				$('input:checkbox[id=chkChild]').prop('checked', true);
			}
			if (this.$store.state.settingInfo.questionPw !== '' && this.$store.state.settingInfo !== undefined) {
				this.setPw = true;
				this.password = this.$store.state.settingInfo.questionPw;
			}
		} catch (e) {
			alert(e);
		}
	},
	methods: {
		pageBefore() {
			this.$router.go(-1);
		},
		popup() {
			popOpenAndScrollNone('#dimIPSetting .dim-popup-mark', '#dimIPSetting .dim-popup-content');
		},
		moveLicense() {
			this.$router.push('/setting/license');
		},
		moveQuestion() {
			this.$router.push('/setting/question');
		},
		modalOKFunction() {
			let chkHosp = $('#chkHosp').is(':checked') == true ? 'Y' : 'N';
			let chkNat = $('#chkNat').is(':checked') == true ? 'Y' : 'N';
			let chkPsy = $('#chkPsy').is(':checked') == true ? 'Y' : 'N';
			let chkChild = $('#chkChild').is(':checked') == true ? 'Y' : 'N';
			let questionPw = this.setPw ? this.password : '';

			//옵션 저장 정보
			let json = JSON.stringify({
				//ip: this.$store.state.settingInfo.ip,
				//port: this.$store.state.settingInfo.port,
				chkHosp: chkHosp,
				chkNat: chkNat,
				chkPsy: chkPsy,
				chkChild: chkChild,
				questionPw: questionPw
			});
			this.$util.setOption(json);
		},
		clickCheckupSave() {
			this.modalData.msg = '문진 설정을 저장하시겠습니까?';
			popOpenAndScrollNone(`#${this.modalData.id} .dim-popup-mark`, `#${this.modalData.id} .dim-popup-content`);
		},
		changeSetPw() {
			if (this.setPw) {
				this.propData = {
					closeFuncName: 'setPinOff',
					rightFuncName: 'setPinOn'
				};
				this.$refs.pinPasswordRef.open();
			} else {
				this.password = '';
			}
		},
		// 모달창 관련 : 문자열로 함수 실행
		parentFunc(functionName, param) {
			this[functionName](param);
		},
		setPinOff() {
			this.setPw = false;
		},
		setPinOn(obj) {
			this.password = obj.password;
		}
	}
};
</script>

<style scoped src="../../assets/css/setting.css"></style>
